import type { LevelType, LightingEffectType } from '../composition/composition.d'

const levels: LevelType[] = ["lvl1", "lvl2", "lvl3", "lvl4"]


export const getLightingEffectOrder = (lightingEffect: LightingEffectType) => {
    let order = ""

    levels.forEach(level => {
        if (lightingEffect?.[level]?.order) {
            order += lightingEffect[level].order.toString().padStart(2, "0")
        } else order += "00"
    })

    return order
}

export default {
    getLightingEffectOrder
}